import { InfoOutlined, InfoRounded } from "@mui/icons-material";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { deepOrange, green, grey, orange, red, yellow } from "@mui/material/colors";
import axios from "axios";
import { allOption, selectOptKeyName } from "data/globalData";
import { arrType, datatypes, inputTypes } from "data/globalData";
import dayjs from "dayjs";
import moment from "moment";
import { calculateTotalMrpByNsvDisc } from "utils/calcultateAOPDataColumns";
import { isStartDateGraterThanEndDate } from "utils/customDateFunctions";
import { multiSort } from "utils/multiColumnSort";
import { convertCrToNormalVaue, convertValueInCr } from "utils/roundDecimalValue";

export const blueShade = "#9fc5e8";
export const blueShade2 = "#cfe2f3";
export const blueShade3 = "#e2e9f0";

export const unitColIdentifier = "is_unit";

export const tableBorderStyle = `1px solid ${grey[200]}`;

export const aopDefRenderCellStyle = {
	boxSizing: "border-box",
	borderBottom: tableBorderStyle,
	borderRight: tableBorderStyle,
};

export const getFileSignedUrl = async (filePath) => {
	if (!filePath) throw new Error("No File Path Found");
	const {
		data: { result },
	} = await axios.post("/api/aop/generate_signed_url", {
		filePath,
	});

	return result.url;
};

export const defRenderHeader = ({ col }) => {
	return (
		<Box
			height="100%"
			width="100%"
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				boxSizing: "border-box",
				p: "2px",
				overflow: "hidden",
				textOverflow: "ellipsis",
			}}>
			<Typography variant="body2" fontWeight={600} noWrap padding={0}>
				{col?.name}
			</Typography>
		</Box>
	);
};

export const blueRenderCell = ({ row, field }) => {
	let sx = { background: blueShade3, display: "flex", justifyContent: "center", alignItems: "center" };
	if (row[unitColIdentifier] === "units") sx = { display: "flex", justifyContent: "center", alignItems: "center" };
	return (
		<Box fontWeight={400} height="100%" width="100%" sx={sx}>
			{row[field]}
		</Box>
	);
};

export const defRenderHeaderWithSX =
	(sx = {}) =>
	({ col }) => {
		return (
			<Box
				sx={{
					height: "100%",
					width: "100%",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					overflow: "hidden",
					textOverflow: "ellipsis",
					...sx,
				}}>
				<Typography variant="body2" fontWeight={600} noWrap padding={0}>
					{col?.name}
				</Typography>
			</Box>
		);
	};

export const ProjectionColumnHeader = ({ col }) => {
	return (
		<Box
			fontWeight={400}
			height="100%"
			width="100%"
			sx={{ background: blueShade2, display: "flex", justifyContent: "center", alignItems: "center" }}>
			{col?.name}
		</Box>
	);
};

export const defRenderCellWithSX =
	(sx = {}) =>
	({ row, field }) => {
		let finalSx = { width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", ...sx };
		if (row[unitColIdentifier] === "units")
			finalSx = {
				width: "100%",
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				fontStyle: "italic",
				...sx,
			};
		return (
			<Box fontWeight={400} sx={finalSx}>
				{row[field] ?? ""}
			</Box>
		);
	};
export const StandardRenderCellWithChildren = ({ children, row, field, sx }) => {
	// if (field === "BRAND") console.log(row, "sehgriwdkf");
	let finalSx = { width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", ...sx };
	if (row[unitColIdentifier] === "units")
		return <Box sx={{ ...finalSx, fontStyle: "italic", fontWeight: 400 }}>{row[field] ?? ""}</Box>;
	else return <Box sx={finalSx}>{children ? children : row[field] ?? ""}</Box>;
};
export const BackgroundChangeByBehaviour = ({ children }) => {
	let finalSx = { width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" };
	return <Box sx={finalSx}>{children}</Box>;
};
export const PercentBackgroundColor = ({ children, value, reverse, range = "medium" }) => {
	let finalSx = { width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" };
	let color = green[400];

	if (range === "small")
		if (reverse) {
			if (value >= 0) color = yellow[200];
			else if (value < 0) color = green["A400"];
			else if (value < 5) color = orange[200];
			else color = orange[200];
		} else {
			if (value >= 0) color = green["A400"];
			else if (value < 0) color = yellow[200];
			else if (value < 5) color = orange[200];
			else color = orange[200];
		}
	if (range === "medium")
		if (reverse) {
			if (value > 0) color = yellow[200];
			else if (value > 20) color = orange[200];
			else if (value < 0) color = green["A400"];
			else if (value < -20) color = orange["A700"];
			else color = yellow["200"];
		} else {
			if (value > 99) color = green["A400"];
			else if (value > 89) color = green["A400"];
			else if (value > 60) color = yellow[200];
			else if (value > 40) color = orange[200];
			else color = red["A100"];
		}

	return <Box sx={{ ...finalSx, background: color }}>{children}</Box>;
};
export const defRenderCell = ({ row, field }) => {
	let sx = {
		width: "100%",
		height: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		boxSizing: "border-box",
	};
	if (row[unitColIdentifier] === "units") sx = { ...sx, fontStyle: "italic", padding: "0px 4px" };
	return (
		<Box sx={sx}>
			<Typography variant="body2" fontWeight={400} noWrap width="90%">
				{row[field] ?? " "}
			</Typography>
		</Box>
	);
};
export const displayInCrRenderCell = ({ row, field }) => {
	let sx = { width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" };
	if (row[brandColumn.key] === "units")
		sx = { width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" };
	return (
		<Box fontWeight={400} sx={sx}>
			{row[brandColumn.key] === "units"
				? field === brandColumn.key
					? ""
					: row[field]
				: Number(row[field])
				? convertValueInCr(row[field])
				: 0}
		</Box>
	);
};
export const displayRenderCellWithInfoToolTip =
	(infoCol) =>
	({ row, field }) => {
		return (
			<StandardRenderCellWithChildren field={field} row={row}>
				{/* <Box display="flex" width="100%" alignItems="center"> */}
				<Tooltip title={row?.[infoCol] ? `Max Date ${row?.[infoCol]}` : "No Date"}>
					<InfoOutlined fontSize="small" sx={{ color: row?.[infoCol] ? grey[300] : orange[300] }} />
				</Tooltip>
				<Typography pl={1} variant="body2" fontWeight={400} width={"80%"} noWrap pr={1} textAlign="center">
					{row[field]}
				</Typography>
				{/* </Box> */}
			</StandardRenderCellWithChildren>
		);
	};

export const brandColumn = {
	name: "Brand",
	key: "BRAND",
	input_type: inputTypes.MULTIPLE_SELECT.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
	select_options: {
		type: arrType,
		list: [
			// { name: allOption, key: allOption },
			{ name: "MAINLINE", key: "MAINLINE" },
			{ name: "GUILD", key: "GUILD" },
		],
	},
	renderHeader: defRenderHeader,
	renderCell: defRenderCell,
	headerSx: { background: grey[300] },

	headerClassName: "default-header",
	unit: "",
};
export const channelColumn = {
	name: "Channel",
	key: "CHANNEL",
	input_type: inputTypes.MULTIPLE_SELECT.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
	select_options: {
		type: arrType,
		list: [
			// { name: allOption, key: allOption },
			{ name: "MAINLINE", key: "MAINLINE" },
			{ name: "GUILD", key: "GUILD" },
		],
	},
	renderHeader: defRenderHeader,
	headerSx: { background: grey[300] },
	renderCell: defRenderCell,
	headerClassName: "default-header",
	unit: "",
};
export const daysLeftColumn = {
	name: "Days Left",
	key: "days_left",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
	renderHeader: defRenderHeader,
	headerSx: { background: grey[300] },
	renderCell: defRenderCell,
	headerClassName: "default-header",
};

export const reportModes = {
	OPS: { name: "Ops", key: "OPS", table_name: "GP WITH CH MARGIN" },
	FINANCE: { name: "Finance", key: "FINANCE", table_name: "GP WITHOUT CH MARGIN" },
};

export const unitRow = {
	[unitColIdentifier]: "units",
	BRAND: "",
	CHANNEL: "",
	aop: "INR CR",
	aop_ach: "INR CR",
	ach: "%",
	gp_val: "INR CR",
	gp_percent: "%",
	days_left: "#",
	projected_sales: "INR CR",
	projected_dis: "%",
	projected_gp_percent: "%",
	projected_gp_val: "INR CR",
	projected_sale_per_day: "INR CR",
};
export const staticBrandWiseData = [
	{
		BRAND: "THOR",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RSM",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
];
export const staticChannelWiseData = [
	{
		BRAND: "THOR",
		CHANNEL: "EBO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "THOR",
		CHANNEL: "MBO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "THOR",
		CHANNEL: "LFS",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "MP",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "MP-OR",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "CORP",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "D2C-INT",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "MP-INT",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "QC",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
];
export const staticCombinedData = [
	{
		BRAND: "THOR",
		CHANNEL: "EBO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "THOR",
		CHANNEL: "MBO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "THOR",
		CHANNEL: "LFS",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "THOR",
		CHANNEL: "MP",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "THOR",
		CHANNEL: "MP-OR",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "THOR",
		CHANNEL: "CORP",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "THOR",
		CHANNEL: "D2C-INT",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "THOR",
		CHANNEL: "MP-INT",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "THOR",
		CHANNEL: "QC",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "EBO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "MBO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "LFS",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "MP",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "MP-OR",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "CORP",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "D2C-INT",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "MP-INT",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		BRAND: "RR",
		CHANNEL: "QC",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
];

export const defBqRowData = {
	NSV_AOP_VAL: 0,
	NSV_ACH_VAL: 0,
	CM_GP_AOP_VAL: 0,
	GP_AOP_VAL: 0,
	CM_GP_ACH_VAL: 0,
	GP_ACH_VAL: 0,
	CM_TAXABLE_AOP_VAL: 0,
	TAXABLE_AOP_VAL: 0,
	CM_TAXABLE_ACH_VAL: 0,
	TAXABLE_ACH_VAL: 0,
	MRP_REV: 0,
	COGS_REV: 0,
	// LAST_DATE: null,
	// BRAND: "",
	// CHANNEL: "",
};
export const defSqlRowData = {
	PROJ_NSV: 0,
	PROJ_CM_TAXABLE_VAL: 0,
	PROJ_TAX: 0,
	PROJ_DIS: 0,
	PROJ_TAX_PRECENT: 0,
	PROJ_TOTAL_MRP: 0,
	PROJ_TOTAL_COGS: 0,
	LAST_UPDATED_BY: "",
	// PROJ_TOTAL_MRP: 0,
	// BRAND: "", CHANNEL: ""
};
export const defAOPOtherData = {
	PROJ_TOTAL_MRP: 0,
};
export const setBqDataInRow = (bqRow, rowToUpdate) => {
	return {
		...rowToUpdate,
		NSV_AOP_VAL: rowToUpdate["NSV_AOP_VAL"] + bqRow["NSV_AOP_VAL"],
		NSV_ACH_VAL: rowToUpdate["NSV_ACH_VAL"] + bqRow["NSV_ACH_VAL"],
		CM_GP_AOP_VAL: rowToUpdate["CM_GP_AOP_VAL"] + bqRow["CM_GP_AOP_VAL"],
		CM_GP_ACH_VAL: rowToUpdate["CM_GP_ACH_VAL"] + bqRow["CM_GP_ACH_VAL"],
		CM_TAXABLE_AOP_VAL: rowToUpdate["CM_TAXABLE_AOP_VAL"] + bqRow["CM_TAXABLE_AOP_VAL"],
		CM_TAXABLE_ACH_VAL: rowToUpdate["CM_TAXABLE_ACH_VAL"] + bqRow["CM_TAXABLE_ACH_VAL"],
		GP_ACH_VAL: rowToUpdate["GP_ACH_VAL"] + bqRow["GP_ACH_VAL"],
		GP_AOP_VAL: rowToUpdate["GP_AOP_VAL"] + bqRow["GP_AOP_VAL"],
		TAXABLE_ACH_VAL: rowToUpdate["TAXABLE_ACH_VAL"] + bqRow["TAXABLE_ACH_VAL"],
		TAXABLE_AOP_VAL: rowToUpdate["TAXABLE_AOP_VAL"] + bqRow["TAXABLE_AOP_VAL"],
		MRP_REV: +rowToUpdate["MRP_REV"] + +bqRow["MRP_REV"],
		COGS_REV: +rowToUpdate["COGS_REV"] + +bqRow["COGS_REV"],
		LAST_DATE: rowToUpdate["LAST_DATE"]
			? isStartDateGraterThanEndDate(rowToUpdate["LAST_DATE"], bqRow["LAST_DATE"])
				? rowToUpdate["LAST_DATE"]
				: bqRow["LAST_DATE"]
			: bqRow["LAST_DATE"],
	};
};

export const aopMrpToCogsDefaultData = {
	"RARE RABBIT": 15,
	RAREISM: 18,
	"RARE ONES": 15,
	RAREZ: 15,
};
export const setAopProjectionDatainRow = (sqlRow, rowToUpdate) => {
	return {
		...rowToUpdate,
		PROJ_NSV: rowToUpdate["PROJ_NSV"] + convertCrToNormalVaue(sqlRow["PROJ_NSV"]),
		PROJ_CM_TAXABLE_VAL: rowToUpdate["PROJ_CM_TAXABLE_VAL"] + convertCrToNormalVaue(sqlRow["PROJ_CM_TAXABLE_VAL"]),
		PROJ_TAX: rowToUpdate["PROJ_TAX"] + convertCrToNormalVaue(sqlRow["PROJ_TAX"]),
		PROJ_TOTAL_MRP: rowToUpdate["PROJ_TOTAL_MRP"] + convertCrToNormalVaue(sqlRow["PROJ_TOTAL_MRP"]),
		PROJ_TOTAL_COGS: rowToUpdate["PROJ_TOTAL_COGS"] + convertCrToNormalVaue(sqlRow["PROJ_TOTAL_COGS"]),
	};
};
const fetchBqData = async (dateRange, setCache, getCache) => {
	try {
		const cacheKey = generateAopBqSaleDataCacheKey(dateRange);
		const cached = getCache(cacheKey);
		if (cached) {
			console.log("loaded bq page data from cache");
			return new Promise(async (reslove, rej) => {
				reslove(cached);
			});
		}
		const res = await axios.get(
			`/api/aop/get_bq_sale_data?startDate=${moment(dateRange?.start_date).format("YYYY-MM-DD")}&endDate=${moment(
				dateRange?.end_date
			).format("YYYY-MM-DD")}`
		);
		setCache(cacheKey, res.data.result);
		return res.data.result;
	} catch (error) {
		return [];
	}
};
const fetchBqProjectionData = async (dateRange) => {
	try {
		const res = await axios.get(
			`/api/aop/get_aop_projection_bw_date_ranges?startDate=${moment(dateRange?.start_date).format(
				"YYYY-MM-DD"
			)}&endDate=${moment(dateRange?.end_date).format("YYYY-MM-DD")}`
		);
		return res.data.result;
	} catch (error) {
		return [];
	}
};
export const generateAopDataCacheKey = (dateRange) => {
	return `AOP-${dayjs(dateRange.start_date).format("YYYY-MM-DD")}-${dayjs(dateRange.end_date).format("YYYY-MM-DD")}`;
};
export const generateAopBqSaleDataCacheKey = (dateRange) => {
	return `AOP-BQ-SALE${dayjs(dateRange.start_date).format("YYYY-MM-DD")}-${dayjs(dateRange.end_date).format("YYYY-MM-DD")}`;
};

export const fetchAOPPageDataFromScratch = async (dateRange, setCache, getCache) => {
	const [bqData, sqlData] = await Promise.all([fetchBqData(dateRange, setCache, getCache), fetchBqProjectionData(dateRange)]);

	const distinctBrands = [
		...new Set(
			[...bqData, ...sqlData].reduce((acc, row) => {
				if (row?.[brandColumn.key]) acc.push(row?.[brandColumn.key]);

				return acc;
			}, [])
		),
	];
	const distinctChannels = [
		...new Set(
			[...bqData, ...sqlData].reduce((acc, row) => {
				if (row?.[channelColumn.key]) acc.push(row?.[channelColumn.key]);
				return acc;
			}, [])
		),
	];
	const filterDropdowns = {
		[brandColumn.key]: distinctBrands,
		[channelColumn.key]: distinctChannels,
	};

	const combineBqAndSqlDataOnBrandChannel = (sqlData, bqData) => {
		const set = new Set(
			[...sqlData, ...bqData]?.map((row) => {
				return `${row.BRAND ?? "BR"}-${row.CHANNEL ?? "CH"}`;
			}, [])
		);
		const sqlDataObj = sqlData?.reduce((acc, row) => {
			acc[`${row.BRAND ?? "BR"}-${row.CHANNEL ?? "CH"}`] = row;
			return acc;
		}, {});
		const bqDataObj = bqData?.reduce((acc, row) => {
			acc[`${row.BRAND ?? "BR"}-${row.CHANNEL ?? "CH"}`] = row;
			return acc;
		}, {});
		const res = [...set].map((key) => {
			let obj = {};
			if (sqlDataObj[key]) obj = { ...obj, ...defSqlRowData, ...sqlDataObj[key] };
			else obj = { ...obj, ...defSqlRowData };
			if (bqDataObj[key]) obj = { ...obj, ...defBqRowData, ...bqDataObj[key] };
			else obj = { ...obj, ...defBqRowData };

			return obj;
		});
		const thor = res
			.filter((row) => row[brandColumn.key] === "THOR")
			.sort(
				multiSort([
					{ key: "BRAND", order: "asc" },
					{ key: "NSV_ACH_VAL", order: "desc" },
				])
			);
		const withoutThor = res
			.filter((row) => row[brandColumn.key] !== "THOR")
			.sort(
				multiSort([
					{ key: "BRAND", order: "asc" },
					{ key: "NSV_ACH_VAL", order: "desc" },
				])
			);

		return [...thor, ...withoutThor];
	};
	const fullData = combineBqAndSqlDataOnBrandChannel(sqlData, bqData);

	return { fullData, filterDropdowns };
};
export const prepareAllAopTableDataBasedOnCombinedData = (fullDataArr) => {
	const brandTableData = () => {
		const distinctBrands = [
			...new Set(
				fullDataArr.reduce((acc, row) => {
					if (row?.[brandColumn.key]) acc.push(row?.[brandColumn.key]);

					return acc;
				}, [])
			),
		];
		return Object.values(
			distinctBrands.reduce((acc, BRAND) => {
				let dataRow = { ...defBqRowData, ...defSqlRowData, ...defAOPOtherData, [brandColumn.key]: BRAND };
				fullDataArr
					?.filter((row) => row?.[brandColumn.key] === BRAND)
					.forEach((row) => {
						dataRow = setBqDataInRow(row, dataRow);
						dataRow = setAopProjectionDatainRow(row, dataRow); //set both sql and Bq Column Data
					});

				acc = { ...acc, [dataRow[brandColumn.key]]: dataRow };
				return acc;
			}, {})
		).sort((a, b) => b.NSV_ACH_VAL - a.NSV_ACH_VAL);
	};
	const channelTableData = () => {
		const distinctChannels = [
			...new Set(
				fullDataArr.reduce((acc, row) => {
					if (row?.[channelColumn.key]) acc.push(row?.[channelColumn.key]);
					return acc;
				}, [])
			),
		];
		return Object.values(
			distinctChannels.reduce((acc, channelStr) => {
				let dataRow = { ...defBqRowData, ...defSqlRowData, ...defAOPOtherData, [channelColumn.key]: channelStr };
				fullDataArr
					?.filter((row) => row?.[channelColumn.key] === channelStr && row?.[brandColumn.key] !== "THOR")
					.forEach((row) => {
						dataRow = setBqDataInRow(row, dataRow);
						dataRow = setAopProjectionDatainRow(row, dataRow);
					});

				acc = { ...acc, [dataRow[channelColumn.key]]: dataRow };
				return acc;
			}, {})
		).sort((a, b) => b.NSV_ACH_VAL - a.NSV_ACH_VAL);
	};
	const fullCombinedData = () => {
		return fullDataArr.reduce((acc, dataObj) => {
			let dataRow = {
				...defBqRowData,
				...defSqlRowData,
				...defAOPOtherData,
				BRAND: dataObj[brandColumn.key],
				CHANNEL: dataObj[channelColumn.key],
			};
			dataRow = setBqDataInRow({ ...defBqRowData, ...dataObj }, dataRow);
			dataRow = setAopProjectionDatainRow({ ...defSqlRowData, ...defAOPOtherData, ...dataObj }, dataRow);
			acc.push(dataRow);
			return acc;
		}, []);
	};
	console.log(fullCombinedData(), brandTableData(), channelTableData(), "combined page data");
	return {
		brandTableData: brandTableData(),
		channelTableData: channelTableData(),
		combinedTableData: fullCombinedData(),
	};
};
